import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounce';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import * as Sentry from "@sentry/react";
import {
    ACTION_USER_LOAD,
    ACTION_USER_LOAD_SUCCESS,
    ACTION_USER_CLEAR,
    IUserLoadAction,
    IUserLoadFailureAction,
    IUserLoadSuccessAction,
    IUserClearAction,
    LoadSuccess,
    LoadFailure,
} from "../actions/user";
import { usersApi } from "../services/users";
import { createSentryAnonymousUser } from "../helpers/errors";


export const
    getUserEpic = (action$): Observable<IUserLoadSuccessAction | IUserLoadFailureAction> => {
        return action$
            .ofType(ACTION_USER_LOAD)
            .mergeMap((_action: IUserLoadAction) => {
                return usersApi
                    .getUser()
                    .map(response =>
                        LoadSuccess(response.user, response.userSummary)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setAuthenticatedUserInSentryEpic = (action$): Observable<never> => {       
        return action$
            .ofType(ACTION_USER_LOAD_SUCCESS)
            .do((action: IUserLoadSuccessAction) => {
                if (action.data && action.data.userName) {
                    const userData = {
                        id: action.data.userName,
                        username: action.data.userName,
                        fullName: action.data.fullName,
                        email: action.data.email,
                        authenticated: true
                    };
                    
                    Sentry.setUser(userData);
                }
            })
            .ignoreElements();
    },
    clearUserEpic = (action$): Observable<never> => {
        return action$
            .ofType(ACTION_USER_CLEAR)
            .do((_action: IUserClearAction) => {
                Sentry.setUser(createSentryAnonymousUser());
            })
            .ignoreElements();
    }